import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FieldItem } from "./FieldItem";
import { Field } from "../types";

export default function SortableField({
  field,
  onRemove,
  sectionId,
  readOnly,
  showDropIndicator = false,
}: {
  field: Field;
  onRemove?: () => void;
  sectionId: string;
  readOnly: boolean;
  showDropIndicator?: boolean;
}) {
  const { attributes, listeners, setNodeRef, transform, isDragging, isOver } =
    useSortable({
      id: `field-${field.id}`,
      data: {
        type: "field",
        field,
        sectionId,
      },
    });

  // Only keep transform in the inline style, the rest is handled by CSS classes
  const style = {
    transform: CSS.Transform.toString(transform),
    zIndex: isDragging ? 999 : "auto",
    // Disable transition during transform
    transition: transform ? undefined : undefined,
  } as const;

  return (
    <div
      ref={setNodeRef}
      style={{ ...style, display: field.hidden ? "none" : "block" }}
      className={`form-field sortable-field  ${isOver ? "drag-over" : ""} ${showDropIndicator ? "show-drop-target" : ""}`}
      data-dragging={isDragging}
      {...(!readOnly ? attributes : {})}
      {...(!readOnly ? listeners : {})}
    >
      <FieldItem
        // ToDo: fix typescript error
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        field={field}
        isDragging={isDragging}
        showDropIndicator={showDropIndicator}
        readOnly={readOnly}
        onRemove={onRemove}
      />
    </div>
  );
}
